// @core/api/endpoints/form/list_form_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFormTypesResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * List form types
 * Returns all registered form types, optionally filtered by product.
 */
export async function ListFormTypes(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    product_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListFormTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/form-types`;
  const requestOptions = options;
  return client.get<ListFormTypesResponse>(requestPath, { ...requestOptions, params });
}
